/* global Fingerprint2 */
import 'whatwg-fetch';

const genDeviceFingerprint = () => {
  const options = {};
  return Fingerprint2.get(options, function (components) {
    const values = components.map(function (component) {
      return component.value;
    });
    return Fingerprint2.x64hash128(values.join(''), 31);
  });
};

const getClientContext = (userTrackingId, bankId) => {
  try {
    const deviceFingerprint = genDeviceFingerprint();
    return JSON.stringify({
      client: {
        user_tracking_id: userTrackingId || 'not set',
        app_title: `${bankId} Web`,
        app_package_name: 'n/a',
        app_version_code: 'n/a',
        app_version_name: 'n/a',
        client_id: deviceFingerprint
      },
      env: {
        platform: navigator.platform,
        platform_version: navigator.appVersion,
        make: navigator.appName,
        locale: navigator.language,
        device_name: navigator.userAgent
      }
    });
  } catch (error) {
    console.error(error);
    return null;
  }
};

const setRequestHeaders = (clientContext, accessToken) => {
  return {
    'x-bpi-client-context': clientContext,
    'x-bpi-service-context': 'USER',
    'x-bpi-version': '1.2.0',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
};

export const fetchConfig = async () => {
  // failure here is caught in the main application catch block
  const resp = await fetch('/config.json');
  return resp.json();
};

/**
 * Fetch a saml token to allow the egain 3rd party integration to function.
 * @param accessToken
 * @param config
 * @param bankId
 * @param userTrackingId - this should be sent by the mobile app, however it currently is not
 * @returns {Promise<{error: (string|clone.statusText|string)}|{error: *}|*>}
 */
export const fetchSAMLToken = async (accessToken, config, bankId, userTrackingId = null) => {
  const clientContext = getClientContext(userTrackingId, bankId);
  const samlTokenPath = `banks/${bankId}/auth/provider/saml/token`;
  const url = `${config.apiUrl}/${samlTokenPath}`;
  const resp = await fetch(url, {
    method: 'POST',
    headers: setRequestHeaders(clientContext, accessToken),
    body: JSON.stringify({ saml_service_provider: 'egain' })
  });
  if (!resp.ok) throw new Error('Unable to fetch SAML token');
  else {
    const json = await resp.json();
    return json.saml_assertion;
  }
};
